import { render } from "./company-tm-details.vue?vue&type=template&id=1ea0b22e&scoped=true"
import script from "./company-tm-details.vue?vue&type=script&lang=js"
export * from "./company-tm-details.vue?vue&type=script&lang=js"

import "./company-tm-details.vue?vue&type=style&index=0&id=1ea0b22e&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea0b22e"]])

export default __exports__